import {add, isWeekend} from "../_snowpack/pkg/date-fns.js";
import {isBankHoliday} from "./date-helpers.js";
export var SKIP_REASON;
(function(SKIP_REASON2) {
  SKIP_REASON2[SKIP_REASON2["LAST_DAY_OF_MONTH"] = 0] = "LAST_DAY_OF_MONTH";
  SKIP_REASON2[SKIP_REASON2["WEEKEND"] = 1] = "WEEKEND";
  SKIP_REASON2[SKIP_REASON2["BANK_HOLIDAY"] = 2] = "BANK_HOLIDAY";
})(SKIP_REASON || (SKIP_REASON = {}));
export function countDates(startDate, dur, _skipped = []) {
  const result = add(startDate, dur);
  const skip = (reason) => [..._skipped, {date: result, reason}];
  if (isWeekend(result)) {
    return countDates(result, {days: 1}, skip(1));
  }
  if (isBankHoliday(result)) {
    return countDates(result, {days: 1}, skip(2));
  }
  return [result, _skipped];
}
